import { getRequest, putRequest, postRequest, deleteRequest, postMultipartRequest } from './api';

const usersApi = {
  async getCurrentUser() {
    const response = await getRequest('/api/user');
    return response;
  },

  async updateUser(userData) {
    const response = await putRequest('/api/user', userData);
    return response;
  },

  async uploadProfilePicture(file) {
    if (!file) {
      throw new Error('No se seleccionó archivo');
    }
    
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await postMultipartRequest('/api/user/profile-picture', formData);
    return response;
  },

  async deleteProfilePicture() {
    const response = await deleteRequest('/api/user/profile-picture');
    return response;
  },

  async setSetupSteps(steps) {
    const response = await postRequest('/api/user/add_setup_steps', { steps });
    return response;
  }
};

export default usersApi;

export const setupSteps = Object.freeze({
  CONECTA_CUENTA_PUBLICITARIA: '1_CONECTA_CUENTA_PUBLICITARIA',
  CREA_OBJETIVOS_AUTOMATICOS_1: '2_CREA_OBJETIVOS_AUTOMATICOS_1',
  CONECTA_SEGUNDA_CUENTA_PUBLICITARIA: '3_CONECTA_SEGUNDA_CUENTA_PUBLICITARIA',
  CREA_OBJETIVOS_AUTOMATICOS_2: '4_CREA_OBJETIVOS_AUTOMATICOS_2',
  CREA_NUEVA_MARCA: '5_CREA_NUEVA_MARCA',
  FINALIZADO: '6_FINALIZADO'
});
